var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useCallback, useEffect, useState } from 'react';
import { Badge } from '@mui/material';
import { Favorite } from '@mui/icons-material';
import { useFavorites } from '../../utils/FavoritesContext';
import { useRouter } from 'next/router';
import { useStyles } from './FloatingFavoritesButton.styles';
function FloatingFavoritesButton() {
    const { classes } = useStyles();
    const { state: favouritesState, syncFromStorage } = useFavorites();
    const router = useRouter();
    const numberOfFavorites = favouritesState.items.length;
    const [slideIn, setSlideIn] = useState(false);
    // Always start as false so SSR and the initial client render both output null,
    // preventing a hydration mismatch when the FavoritesContext loads from storage
    // before React hydrates (which would cause the server's ChatButton slot and the
    // client's FloatingFavoritesButton to differ).
    const [shouldRender, setShouldRender] = useState(false);
    useEffect(() => {
        var _a;
        const storedFavorites = (_a = globalThis.window) === null || _a === void 0 ? void 0 : _a.localStorage.getItem('favorites');
        if (JSON.parse(storedFavorites || '[]').length != numberOfFavorites) {
            syncFromStorage();
            console.log('Favorites synced from storage');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        let timer;
        if (numberOfFavorites > 0) {
            setShouldRender(true);
            timer = setTimeout(() => setSlideIn(true), 250);
        }
        else {
            setSlideIn(false);
            setShouldRender(false);
        }
        return () => clearTimeout(timer);
    }, [numberOfFavorites]);
    const handleClick = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        try {
            // Adding session storage to identify the floating button click of favorites page
            sessionStorage.setItem('favoritesRedirect', 'true');
            yield router.push('/favourites');
        }
        catch (error) {
            console.error('Failed to navigate to favorites:', error);
        }
    }), [router]);
    const badgeContent = useMemo(() => (numberOfFavorites > 99 ? '9+' : numberOfFavorites), [numberOfFavorites]);
    if (!shouldRender) {
        return null;
    }
    return (_jsx("button", { onClick: handleClick, className: `${classes.floatingFavoritesButtonContainer} ${slideIn ? classes.slideIn : classes.slideOut}`, "aria-label": `View ${numberOfFavorites} favorite ${numberOfFavorites === 1 ? 'item' : 'items'}`, type: "button", children: _jsx(Badge, { badgeContent: badgeContent, className: classes.floatingFavoritesBadge, children: _jsx(Favorite, { className: classes.floatingFavoritesIconButton }) }) }));
}
export default FloatingFavoritesButton;
